import http from '../../../utils/fetch';
import updownfile from "../../../utils/updownfile";
export default {

    baseurl:'/api/swyl/v1/manager/SpecialController',

    tejialist:'/api/swyl/v1/tejiashitulist/viewSpecialList',

    fileurl:'/api/file/fileopt',

    kexuanwuliao:'/api/swyl/v1/kexuanwuliao/viewSpecialKexuanwuliao',

    offer:'/api/swyl/v1/special/offer',


    findkexuanwuliao(q){
        return http.post(this.kexuanwuliao + '/findkexuanwuliao',q);
    },

    finddingjia(q){
        return http({
            url: this.offer + '/finddingjia',
            method: 'post',
            params: q
        });
    },

    quedinghaiwaiguonei(q){
        return http({
            url: this.offer + '/quedinghaiwaiguonei',
            method: 'post',
            params: q
        });
    },


    ofselectMap(q){
        return http.post(this.offer + '/selectMap',q);
    },

    findxiangmuchanpin(q){
        return http({
            url: this.offer + '/findxiangmuchanpin',
            method: 'post',
            params: q
        });
    },

    shenpijiazai(q){
        return http({
            url: this.offer + '/shenpijiazai',
            method: 'post',
            params: q
        });
    },

    xunzhaodengji(q){
        return http({
            url: this.offer + '/xunzhaodengji',
            method: 'post',
            params: q
        });
    },

    chuangjiantejia(q){
        return http.post(this.offer + '/chuangjiantejia',q);
    },

    tejiaotejia(q){
        return http.post(this.offer + '/tejiaotejia',q);
    },

    tejiaotejianew(q){
        return http.post(this.offer + '/tejiaotejianew',q);
    },

    luojishanchu(q){
        return http.post(this.offer + '/luojishanchu',q);
    },




}
